import { useState } from 'react';
import { HTTPMethods } from '../yoello-lib/modules/API/API';
import merchantAPIDefs from "../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from '../yoello-lib/modules/API2/useAPIv2';

export interface InvitationsDTO {
    data: Object[];
}

const useAcceptVenueInvitations = () => {

    const [ isLoading, setIsLoading ] = useState(false);
    const [ hasInvitations, setHasInvitations ] = useState(false);

    const { callAPI } = useAPIV2(merchantAPIDefs.invitations, {
        onMountDisabled: true
    });

    const checkForInvitations = (merchantId: string) => {
        return callAPI(HTTPMethods.GET, {
            query: `${merchantId}/venues/invitations`
        })
    }

    const acceptInvitations = (merchantId: string) => {
        return callAPI(HTTPMethods.POST, {
            query: `${merchantId}/venues/invitations/accept`
        })
    }

    const checkAndAcceptInvitations = async (merchantId: string) => {
        setIsLoading(true);
        setHasInvitations(false);
        const invitations = await checkForInvitations(merchantId) as InvitationsDTO;
        if(invitations?.data?.length > 0) {
            setHasInvitations(true);
            await acceptInvitations(merchantId);
        }
        setIsLoading(false);
    }

    return {
        checkAndAcceptInvitations,
        isLoading,
        hasInvitations
    }
}

export default useAcceptVenueInvitations;